import { omit as _omit } from 'lodash';
import { BUILDER_SERVER_STORAGE_TYPE } from './analytics-builder-advanced-settings';

/**
 *
 * @param settingsTemplate
 * @param isStandAloneSync
 * @returns {object}
 */

const buildFileOptions = (settingsTemplate, isStandAloneSync) => {
  if (isStandAloneSync) {
    return {
      settingsJson: {
        minify: settingsTemplate.minifyFile,
        syncs: settingsTemplate.syncInjectorSettings.syncs.map(sync => sync.name),
        storageType: BUILDER_SERVER_STORAGE_TYPE[settingsTemplate.syncInjectorSettings.storage.type],
      },
    };
  }

  const finalBuildOptions = {
    settingsJson: {
      ..._omit(settingsTemplate, ['compressFile']),
      ...(settingsTemplate?.syncInjectorSettings?.storage?.type && {
        syncInjectorSettings: {
          ...settingsTemplate.syncInjectorSettings,
          storage: {
            ...settingsTemplate.syncInjectorSettings.storage,
            type: BUILDER_SERVER_STORAGE_TYPE[settingsTemplate.syncInjectorSettings.storage.type],
          },
        },
      }),
    },
  };

  return finalBuildOptions;
};

export default buildFileOptions;
